import { StepProps } from '@/design_system/Stepper/Stepper';

export const getFilteredStepsForClientStepper = (
  steps: (StepProps & { step: string })[]
): (StepProps & { step: string })[] => {
  const filteredSteps: (StepProps & { step: string })[] = [];

  let stepCurrentlyHidingEverythingUntilNextOccurrence: (typeof steps)[number] | undefined =
    undefined;

  for (const [index, step] of steps.entries()) {
    const futureSteps = steps.slice(index + 1);
    const stepsUntilNextOccurrenceShouldBeHidden =
      (step.step === 'analysis' &&
        step.status === 'cancelled' &&
        futureSteps.some((s) => s.step === 'analysis' || s.step === 'processing')) ||
      (step.step === 'repair' &&
        step.status === 'cancelled' &&
        futureSteps.some((s) => s.step === 'repair' || s.step === 'processing')) ||
      (step.step === 'quality-control' &&
        step.status === 'cancelled' &&
        futureSteps.some((s) => s.step === 'quality-control')) ||
      (step.step === 'processing' && futureSteps.some((s) => s.step === 'processing'));

    if (stepCurrentlyHidingEverythingUntilNextOccurrence) {
      const originStep = stepCurrentlyHidingEverythingUntilNextOccurrence.step;

      const isNextOccurrenceThatCompletesTheIssue =
        ((originStep === 'analysis' && (step.step === 'analysis' || step.step === 'processing')) ||
          (originStep === 'repair' && (step.step === 'repair' || step.step === 'processing')) ||
          (originStep === 'quality-control' && step.step === 'quality-control') ||
          (originStep === 'processing' && step.step === 'processing')) &&
        !stepsUntilNextOccurrenceShouldBeHidden;

      if (isNextOccurrenceThatCompletesTheIssue) {
        stepCurrentlyHidingEverythingUntilNextOccurrence = undefined;
        filteredSteps.push({
          ...step,
          status: step.status === 'pending' ? 'in-progress' : step.status,
        });
      }
    } else {
      if (stepsUntilNextOccurrenceShouldBeHidden) {
        stepCurrentlyHidingEverythingUntilNextOccurrence = step;
      } else {
        filteredSteps.push(step);
      }
    }
  }

  return filteredSteps;
};
